var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0879 26.8409C21.1308 26.8409 26.8404 21.1315 26.8404 14.0884C26.8404 7.04542 21.1308 1.33594 14.0879 1.33594C7.04493 1.33594 1.33545 7.04542 1.33545 14.0884C1.33545 21.1315 7.04493 26.8409 14.0879 26.8409Z",
    fill: "#FFEF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0876 1.33351C11.5657 1.33337 9.10044 2.08083 7.00344 3.48152C4.90631 4.88221 3.27164 6.87316 2.30596 9.20284C1.34028 11.5324 1.08706 14.0962 1.57816 16.5696C2.06927 19.0432 3.28271 21.3156 5.06519 23.0995L23.0999 5.06621C21.9175 3.88101 20.5127 2.94123 18.9661 2.30061C17.4195 1.66012 15.7617 1.33142 14.0876 1.33351Z",
    fill: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0879 26.8409C21.1308 26.8409 26.8404 21.1315 26.8404 14.0884C26.8404 7.04542 21.1308 1.33594 14.0879 1.33594C7.04493 1.33594 1.33545 7.04542 1.33545 14.0884C1.33545 21.1315 7.04493 26.8409 14.0879 26.8409Z",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1069 23.1084L30.6665 30.6668",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1797 10.3558V9.08057",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0917 10.3555H13.499C13.1011 10.3551 12.7155 10.4933 12.4085 10.7464C12.1014 10.9995 11.8922 11.3516 11.8167 11.7422C11.7413 12.1329 11.8042 12.5377 11.9949 12.887C12.1856 13.2362 12.492 13.5081 12.8614 13.6558L15.4924 14.708C15.8608 14.8562 16.1664 15.1282 16.3564 15.4772C16.5464 15.826 16.6092 16.2304 16.5337 16.6205C16.4582 17.0106 16.2496 17.3624 15.9432 17.6153C15.6368 17.8682 15.252 18.0068 14.8546 18.007H12.2659",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1797 19.2825V18.0073",
    stroke: "#111827",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_69"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.afbd0d59e4f9c23ab072bfbb87943f63.svg";
export { ForwardRef as ReactComponent };